export default __webpack_public_path__ + "static/media/settings.a7ec08cf.svg";